module.exports = __webpack_public_path__ + "media/pricing/Job_Safety_Analysis-db7dbd30.pdf";